export default __webpack_public_path__ + "ae9878a0ed980fbd57d608e2cb9e7231.png";